"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSize = void 0;
const polished_1 = require("polished");
function createSize() {
    return function (size) {
        return (0, polished_1.rem)(size);
    };
}
exports.createSize = createSize;
exports.default = createSize;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY3JlYXRlLXNpemUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi90aGVtaW5nL2NyZWF0ZS1zaXplLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLHVDQUErQjtBQU0vQixTQUFnQixVQUFVO0lBQ3hCLE9BQU8sVUFBVSxJQUFJO1FBQ25CLE9BQU8sSUFBQSxjQUFHLEVBQUMsSUFBSSxDQUFDLENBQUM7SUFDbkIsQ0FBQyxDQUFDO0FBQ0osQ0FBQztBQUpELGdDQUlDO0FBRUQsa0JBQWUsVUFBVSxDQUFDIn0=